import { useIsVerified } from "src/components/email-verification";
import {
  MainCard,
  MainCardTitle,
  MainCardContent,
} from "src/components/main-card-type.tsx";
import { useEffect, useState } from "react";

import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  removeMask,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { calcularCDB, CDBResponse } from "../utilis/calculo";
const calculatorKey = "calculadora-cdb";

export const CalculadoraCDBInputCard = ({
  setResults,
}: {
  setResults: (value: CDBResponse | null) => void;
}) => {
  const [message, setMessage] = useState<string>("");
  const [investimentoInicial, setInvestimentoInicial] = useState("");
  const [investimentoMensal, setInvestimentoMensal] = useState("");
  const [rendimentoCDI, setRendimentoCDI] = useState("");
  const [tempoRendimento, setTempoRendimento] = useState("");
  const [tempoRendimentoType, setTempoRendimentoType] = useState("");

  function clear() {
    setMessage("");
  }

  const isVerified = useIsVerified();
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      investimentoInicial,
      investimentoMensal,
      rendimentoCDI,
      tempoRendimento,
      tempoRendimentoType,
    });
  }
  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setInvestimentoInicial((savedData.investimentoInicial as string) || "");
    setInvestimentoMensal((savedData.investimentoMensal as string) || "");
    setRendimentoCDI((savedData.rendimentoCDI as string) || "");
    setTempoRendimento((savedData.tempoRendimento as string) || "");
    setTempoRendimentoType(
      (savedData.tempoRendimentoType as string) || "anual",
    );
  }, []);

  function funcaoDeCalculo() {
    if (!investimentoInicial) {
      setMessage("Por favor adicione um valor ao Investimento Inicial.");
      setResults(null);
      return;
    }
    if (!rendimentoCDI) {
      setMessage("Por favor adicione um valor ao CDI.");
      setResults(null);
      return;
    }
    if (!tempoRendimento) {
      setMessage("Por favor adicione um valor ao Tempo de Rendimento.");
      setResults(null);
      return;
    }
    const fatorCDI = removeMask(rendimentoCDI) / 100;

    let results = calcularCDB(
      investimentoInicial,
      investimentoMensal,
      fatorCDI,
      tempoRendimento,
      tempoRendimentoType as "anual" | "mensal",
    );

    setResults(results);
  }
  return (
    <MainCard>
      <MainCardTitle>Calculadora de CDB</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          funcaoDeCalculo();
          checkCalculatorUsageLimitAndRedirect(handleSave);
        }}
      >
        <MainCardContent>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Investimento inicial
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={investimentoInicial}
                onChange={(event) =>
                  setInvestimentoInicial(sanitizeBrlValue(event))
                }
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Investimento mensal
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={investimentoMensal}
                onChange={(event) =>
                  setInvestimentoMensal(sanitizeBrlValue(event))
                }
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              CDI
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                %
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="115%"
                type="text"
                value={rendimentoCDI}
                onChange={(event) => setRendimentoCDI(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="interest-rate"
            >
              Tempo de rendimento
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]"></span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="interest-rate"
                placeholder={
                  tempoRendimentoType === "mensal" ? "3 meses" : "1 ano"
                }
                type="text"
                value={tempoRendimento}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9,]/g, "");
                  setTempoRendimento(value);
                }}
              />
              <select
                className="border-l p-2 bg-white"
                value={tempoRendimentoType}
                onChange={(event) => setTempoRendimentoType(event.target.value)}
              >
                <option value="anual">anual</option>
                <option value="mensal">mensal</option>
              </select>
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>

      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
